import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articlesData';
import type { Article } from '@/mocks/articlesData';

const articleImages: Record<string, string> = {
  'art-001': 'https://readdy.ai/api/search-image?query=A%20warm%20intimate%20scene%20of%20a%20couple%20sharing%20a%20quiet%20evening%20moment%20together%20on%20a%20comfortable%20sofa%2C%20soft%20warm%20lighting%20from%20a%20table%20lamp%2C%20cozy%20living%20room%20atmosphere%2C%20emotional%20connection%2C%20gentle%20and%20tender%20mood%2C%20editorial%20lifestyle%20photography%20with%20soft%20focus&width=800&height=500&seq=art-thumb-001&orientation=landscape',
  'art-002': 'https://readdy.ai/api/search-image?query=An%20elegant%20minimalist%20living%20space%20with%20warm%20morning%20sunlight%20streaming%20through%20large%20windows%2C%20a%20beautifully%20set%20breakfast%20table%20with%20fresh%20flowers%20and%20ceramic%20tableware%2C%20quality%20lifestyle%20aesthetic%2C%20clean%20and%20serene%20atmosphere%2C%20soft%20cream%20and%20beige%20tones%2C%20editorial%20interior%20photography&width=800&height=500&seq=art-thumb-002&orientation=landscape',
  'art-003': 'https://readdy.ai/api/search-image?query=A%20serene%20person%20sitting%20alone%20by%20a%20window%20with%20warm%20afternoon%20light%2C%20holding%20a%20cup%20of%20tea%2C%20peaceful%20and%20contemplative%20expression%2C%20soft%20natural%20lighting%2C%20minimalist%20interior%20with%20a%20small%20plant%2C%20calm%20and%20introspective%20mood%2C%20fine%20art%20portrait%20photography&width=800&height=500&seq=art-thumb-003&orientation=landscape',
};

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block text-xs font-medium tracking-widest uppercase text-accent-600 bg-accent-100/60 px-4 py-1.5 rounded-full mb-4">
            精选推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            温暖内容，与你共鸣
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            精选优质文章，涵盖情感陪伴、品质生活、心灵成长等多个维度
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {featured.map((article: Article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={articleImages[article.id] || articleImages['art-001']}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                    {article.categoryLabel}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {article.publishedAt}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-md border border-secondary-300 text-sm text-secondary-700 font-medium whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-secondary-100 hover:border-secondary-400"
          >
            查看全部文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}